import { render, staticRenderFns } from "./diseaseTestList.vue?vue&type=template&id=1538bfa8&scoped=true"
import script from "./diseaseTestList.vue?vue&type=script&lang=js"
export * from "./diseaseTestList.vue?vue&type=script&lang=js"
import style0 from "./diseaseTestList.vue?vue&type=style&index=0&id=1538bfa8&prod&scoped=true&lang=css"
import style1 from "./diseaseTestList.vue?vue&type=style&index=1&id=1538bfa8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1538bfa8",
  null
  
)

export default component.exports